import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaRegCopy } from "react-icons/fa";

function CheckMark({ isVisible }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transition: "all 300ms ease-in-out" }}
    >
      <path
        d="M13.25 4.75L6 12L2.75 8.75"
        style={{
          strokeDasharray: 50,
          strokeDashoffset: isVisible ? 0 : 50,
          transition: "all 300ms ease-in-out",
        }}
      />
    </svg>
  );
}

const EndUserTestCredentials = ({ show, close, testCredentials, handleCopy, copied }) => {
  const [copiedEmail, setCopiedEmail] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);

  // Function to copy email
  const handleCopyEmail = () => {
    const emailText = `${testCredentials.email}`;
    navigator.clipboard.writeText(emailText)
      .then(() => {
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
      })
      .catch(err => console.error("Failed to copy email:", err));
  };

  // Function to copy password
  const handleCopyPassword = () => {
    const passwordText = `${testCredentials.password}`;
    navigator.clipboard.writeText(passwordText)
      .then(() => {
        setCopiedPassword(true);
        setTimeout(() => setCopiedPassword(false), 2000);
      })
      .catch(err => console.error("Failed to copy password:", err));
  };

  return (
    <Modal
      show={show}
      onHide={close}
      centered
      dialogClassName="custom-modal-enduser"
      style={{
        content: {
          width: "600px",
          height: "300px",
          margin: "auto",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          border: "1px solid #ccc",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          zIndex: 1000,
        },
      }}
    >
      <Modal.Header className="modal-header-custom" closeButton>
        <Modal.Title style={{
          marginBottom: "20px",
          fontSize: "20px",
          textAlign: "center",
        }}>
          End User Test Credential - Muvi One
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold", textAlign: "left", padding: "10px" }}>Email</td>
              <td style={{ textAlign: "left", padding: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  {testCredentials.email}
                  <FaRegCopy
                    onClick={handleCopyEmail}
                    style={{ cursor: "pointer", marginLeft: "10px", color: copiedEmail ? "green" : "#006EFA" }}
                    title="Copy Email"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold", textAlign: "left", padding: "10px" }}>Password</td>
              <td style={{ textAlign: "left", padding: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  {testCredentials.password}
                  <FaRegCopy
                    onClick={handleCopyPassword}
                    style={{ cursor: "pointer", marginLeft: "10px", color: copiedPassword ? "green" : "#006EFA" }}
                    title="Copy Password"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <Button
          onClick={handleCopy}
          // onClick={() => copyToClipboard(`Email: ${testCredentials.email}\nPassword: ${testCredentials.password}`, "credentials")}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            // backgroundColor: "#0cb9f2",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "16px",
          }}
        >
          {copied ? <CheckMark isVisible={true} /> : "Copy Credentials"}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default EndUserTestCredentials;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/EndUserTestCredentails.js